import { render, staticRenderFns } from "./modalInserirClienteNovoEtapa.vue?vue&type=template&id=077a87fc&"
import script from "./modalInserirClienteNovoEtapa.vue?vue&type=script&lang=js&"
export * from "./modalInserirClienteNovoEtapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports